import type { ItemMenuTypes, IconProps } from "./dto";

import PlusSvg from "../../assets/icon-plus.svg";
import EditSvg from "../../assets/icon-edit.svg";
import DeleteSvg from "../../assets/icon-delete.svg";
import CopySvg from "../../assets/icon-copy.svg";
import ConfigSvg from "../../assets/icon-config.svg";
import CancelSvg from "../../assets/icon-cancel.svg";
import AddSvg from "../../assets/icon-plus.svg";
/**
 * 预设的操作
 */
const OPERATION: Record<ItemMenuTypes, IconProps> = {
  edit: {
    icon: EditSvg,
    name: "编辑",
    type: "edit",
  },
  config: {
    icon: ConfigSvg,
    name: "配置",
    type: "config",
  },
  delete: {
    icon: DeleteSvg,
    name: "删除",
    type: "delete",
  },
  add: {
    icon: PlusSvg,
    name: "新增",
    type: "add",
  },
  copy: {
    icon: CopySvg,
    name: "复制",
    type: "copy",
  },
  cancel: {
    icon: CancelSvg,
    name: "取消关联",
    type: "cancel",
  },
  addEquip: {
    icon: AddSvg,
    name: "新增辅助设备",
    type: "addEquip",
  },
};

export { OPERATION };
